// biome-ignore-all lint/correctness/useHookAtTopLevel: Anche se è condizionale, garantiamo l'ordine di esecuzione manualmente.
// Il problema è l'interfaccia di `useWatch` che non permette di passare
// l'oggetto condizionale come argomento.
import { useFormContext, useWatch } from 'react-hook-form';

export function useFormValues(name?: string) {
  const { getValues } = useFormContext();
  if (name) {
    return {
      ...useWatch({ name }),
      ...getValues(name),
    };
  }
  return {
    ...useWatch(), // subscribe to form value updates
    ...getValues(), // always merge with latest form values
  };
}
